var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-dialog",
    {
      staticClass: "create-circle-dialog",
      attrs: { "md-active": _vm.internalVisible },
      on: {
        "update:mdActive": function($event) {
          _vm.internalVisible = $event
        },
        "update:md-active": function($event) {
          _vm.internalVisible = $event
        }
      }
    },
    [
      _c("md-dialog-title", [
        _vm._v("Add " + _vm._s(_vm.label) + " "),
        _c("span", { staticClass: "minimum" }, [
          _vm._v("(Minimum " + _vm._s(_vm.minLength) + " characters)")
        ])
      ]),
      _vm._v(" "),
      _c(
        "md-dialog-content",
        [
          _c(
            "md-field",
            [
              _c("label", [_vm._v(_vm._s(_vm.label))]),
              _vm._v(" "),
              _vm.dialogType === "subject"
                ? _c("md-input", {
                    attrs: {
                      placeholder: "Enter a new " + _vm.label.toLowerCase(),
                      maxlength: _vm.maxLength,
                      "md-counter": _vm.maxLength
                    },
                    model: {
                      value: _vm.value,
                      callback: function($$v) {
                        _vm.value = $$v
                      },
                      expression: "value"
                    }
                  })
                : _c("md-textarea", {
                    attrs: {
                      placeholder: "Enter a new " + _vm.label.toLowerCase(),
                      maxlength: _vm.maxLength,
                      "md-counter": _vm.maxLength,
                      rows: "5"
                    },
                    model: {
                      value: _vm.value,
                      callback: function($$v) {
                        _vm.value = $$v
                      },
                      expression: "value"
                    }
                  })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-dialog-actions",
        [
          _c("md-button", { on: { click: _vm.cancel } }, [_vm._v("Cancel")]),
          _vm._v(" "),
          _c(
            "md-button",
            {
              staticClass: "md-primary",
              attrs: { disabled: _vm.value.trim().length < _vm.minLength },
              on: { click: _vm.confirm }
            },
            [_vm._v("Add")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-103ee31f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-103ee31f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddWizardItem.vue
// module id = null
// module chunks = 